// PrivacyPolicy.jsx
import React from "react";
import { Shield } from "lucide-react";
import "./LegalPages.css";
import Footer from "./footer";

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <div className="legal-header">
          <div className="header-title">
            <Shield className="header-icon blue" />
            <h1>Privacy Policy</h1>
          </div>
          <p className="breadcrumb">Home / Privacy Policy</p>
        </div>

        <section className="legal-section">
          <p>At Niveshly (NextGen Prosperity Pvt. Ltd.), we value your trust and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, share, and safeguard your data when you use our website, mobile applications, or services relating to unlisted and pre1-IPO shares.</p>

          <div><h2>1. Scope & Consent</h2><p>By using our services, you agree to the terms outlined in this Privacy Policy. We comply with the Digital Personal Data Protection Act, 2023 (India) and, where applicable, international standards such as the GDPR (EU).</p></div>

          <div><h2>2. Information We Collect</h2><ul><li><strong>Personal Identifiers:</strong> Name, phone number, email, address.</li><li><strong>Financial Details:</strong> Demat account details, bank details, transaction history.</li><li><strong>Regulatory Information:</strong> PAN, Aadhaar, or other identity proof.</li><li><strong>Technical Data:</strong> IP address, browser type, cookies, device info.</li></ul></div>

          <div><h2>11. Contact Us</h2>
            <div className="contact-box">
              <p className="font-bold">NextGen Prosperity Pvt. Ltd.</p>
              <p>Registered Office: 4E/5, 2nd Floor, Part B, Jhandewalan Extension, Near Videocon Tower, Delhi – 110055</p>
              <p>Email: <a href="mailto:niveshly@gmail.com" className="text-blue-600 hover:underline">niveshly@gmail.com</a></p>
              <p>Phone: +91 9650541082</p>
            </div>
          </div>
        </section>
      </div>
          <Footer/>
    </div>
  );
};

export default PrivacyPolicy;